<div class="footer__head">
  <div class="footer__head-left">
    <div class="footer__logo"></div>

    <shell-language-selector class="footer__language"></shell-language-selector>
  </div>

  @if ((socialLinks | keyvalue).length > 0) {
    <div class="footer__medias medias">
      <div class="medias__title">Social media</div>

      <div class="medias__links">
        @for (item of socialLinks | keyvalue; track item.key) {
          <a class="medias__link link" [href]="item.value" aria-label="media link">
            <i class="icon icon_new" [class]="socialIcons[item.key]"></i>
          </a>
        }
      </div>
    </div>
  }
</div>

<div class="footer__main">
  <div class="footer__counters">
    @if (authState.footerCounters(); as counters) {
      <div class="footer__counter counter">
        <div class="counter__icon icon icon_new icon_online"></div>

        <div class="counter__info">
          <div class="counter__value">{{ online() | number }}</div>
          <div class="counter__title" i18n="@@main.footer.online">Онлайн</div>
        </div>
      </div>

      <div class="footer__counter counter">
        <div class="counter__icon icon icon_new icon_users icon-translate"></div>

        <div class="counter__info">
          <div class="counter__value">{{ counters['usersCount'] | number }}</div>
          <div class="counter__title" i18n="@@main.footer.players">Игроков</div>
        </div>
      </div>

      <div class="footer__counter counter">
        <div class="counter__icon icon icon_new icon_gamepad"></div>

        <div class="counter__info">
          <div class="counter__value">{{ counters['gamesCount'] | number }}</div>
          <div class="counter__title" i18n="@@main.footer.total_games">Всего игр</div>
        </div>
      </div>

      <div class="footer__counter counter">
        <div class="counter__icon icon icon_new icon_money-2 icon-translate"></div>

        <div class="counter__info">
          <div class="flex items-center">
            <i class="icon_new icon_coinStroke text-[1.5rem] !text-white lg:text-[1.3rem]"></i>
            <span convertAnimation="true" class="counter__value">{{
              counters['usersWonAmount'] | number: '1.0-0'
            }}</span>
          </div>
          <div class="counter__title" i18n="@@main.footer.won">Выиграно</div>
        </div>
      </div>
    }
  </div>
  <div class="flex items-center space-x-6 lg:flex-col-reverse lg:space-x-0">
    <div class="footer__attention-wrapper">
      <div class="footer__attention">
        <img
          loading="lazy"
          class="image"
          src="assets/images/main/main-footer-18.webp"
          alt="Play responsibly"
          fetchpriority="low"
        />
      </div>
    </div>
  </div>
</div>

<div class="footer__bottom">
  <div class="footer__column footer__column_left">
    <div class="footer__date">&copy; 2018 &#8211; {{ currentYear }} CSFail</div>

    <div class="footer__address">
      @if (is6csfail) {
        LLC “Prime Lab” 720040, Kyrgyz Republic, Bishkek, Zhumabeka Street 105/1 OKPO 31816860
        <!-- @if (isRuLanguage) {
          AG AUTOMOTIVE LOGISTICS AND MANAGEMENT PTE. LTD.: Company number 202350466K, 68 CIRCULAR ROAD #02-01 SINGAPORE
          (049422)
        } @else {
          ITSFAIL LTD: Company number 13246765, 16 John Nicholas Crescent, Ellesmere Port, Cheshire, United Kingdom,
          CH65 2DL
        } -->
      } @else {
        ITSFAIL LTD: 6 John Nicholas Crescent, Ellesmere Port, CH65 2DL, Cheshire, United Kingdom of Great Britain and
        Northern Ireland, with company number 13246765
      }
    </div>
  </div>

  <div class="footer__links">
    <button class="footer__nav-item link intercomTrigger text-start" i18n="@@main.footer.nav.support" type="button">
      Поддержка
    </button>

    <a class="footer__nav-item link" routerLink="/support/contacts" i18n="@@main.footer.nav.contacts">Контакты</a>

    <a class="link footer__nav-item" i18n="@@main.footer.nav.user_policy" routerLink="/support/user-agreement">
      Пользовательское соглашение
    </a>

    <a class="link footer__nav-item" i18n="@@main.footer.nav.privacy_policy" routerLink="/support/privacy-policy">
      Privacy Policy
    </a>

    <a class="link footer__nav-item" i18n="@@main.footer.nav.provably_fair" routerLink="/provably-fair">
      Provably fair
    </a>
    <a class="link footer__nav-item" i18n="@@header.referrals" routerLink="/referrals"> Партнерство </a>
  </div>

  <!-- <div class="footer__apps">
      <a
        class="footer__app app app_android link"
        aria-label="app angroid"
        href="https://play.google.com/store/apps/details?id=com.dropers.csfail"
      >
        <div class="app__logo"></div>
        <div class="app__text"></div>
      </a>
    </div> -->
</div>
